import SoftwareVersionService from 'actions/version/software_version_service';

export default class UpgradeSoftware {
  run() {
    SoftwareVersionService.upgrade();
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/version/upgrade_software.js